var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('div',{staticClass:"nav-wrapper light-blue darken-3"},[_c('div',{staticClass:"col s12",staticStyle:{"padding-left":".5rem"}},_vm._l((_vm.breadcrumb),function(crumb){return _c('router-link',{key:crumb.link,staticClass:"breadcrumb",attrs:{"to":crumb.link}},[_vm._v(" "+_vm._s(crumb.name)+" ")])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }